<template>
    <div class="bookings-index action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.transaction"
                :length="1"
                :color="
                    props.row.transaction ==
                    trans('bookings.label.transaction_buy')
                        ? '2'
                        : '15'
                "
            >
            </colored-letter-square>
            <div
                slot="actions"
                slot-scope="props"
                :client="client"
                :license="license"
            >
                <bookings-table-actions
                    :data="props.row"
                    :index="props.index"
                    :client="client"
                    :license="license"
                ></bookings-table-actions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    props: ['client', 'license', 'canUpdateBookings'],

    data() {
        let columns = [
            'cls_column',
            'created_at',
            'transaction',
            'next_booking_at',
            'license_amount',
            'repeat',
        ];
        if (this.canUpdateBookings) {
            columns.push('actions');
        }
        return {
            tableData: [],
            columns: columns,
            options: {
                headings: {
                    cls_column: '',
                    license_amount: this.trans('bookings.label.license_amount'),
                    repeat: this.trans('bookings.label.repeat'),
                    transaction: this.trans('bookings.label.transaction'),
                    created_at: this.trans('bookings.label.created_at'),
                    next_booking_at: this.trans(
                        'bookings.label.next_booking_at'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: ['created_at', 'transaction', 'license_amount'],
            },
        };
    },

    methods: {
        fetch() {
            axios
                .get(
                    this.route('tenantapi.bookings.index', {
                        client: this.client.id,
                        license: this.license.id,
                    })
                )
                .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    created() {
        this.fetch();

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });

        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });
    },
};
</script>
